import { useStore } from "../../state/useStore.ts";
import { K } from "../../state/keys.ts";
import { game } from "../../state/index.ts";
import { practiceActionsView } from "../../domain/practiceActions.ts";
import * as practice from "../../legacy/practice.js";

/**
 * Taking back the last move, under the board.
 *
 * It lives there — where the move back and move forward arrows used to be — because that is where the
 * hand already is, and because having both an arrow that *looks* at the previous move and a button
 * that *undoes* it, side by side, is a puzzle nobody asked for. Looking back is still there: click a
 * move in the scoresheet, or use the arrow keys.
 */
export function TakeBack() {
    const status = useStore(K.practice.status);
    const line = useStore(K.practice.line);
    const moves = useStore(K.practice.moves) || [];

    const view = practiceActionsView({
        status,
        hasLine: !!line,
        isUserTurn: !!line && game.turn() === line.color[0],
        hasOwnMove: moves.some((move) => move && move.actor === "user"),
    });

    if (view.hidden) return null;
    return (
        <button type="button" class="btn btn-ghost btn-sm" disabled={view.takeBackDisabled}
                title="Take your last move back (T)"
                onClick={() => practice.takeBack()}>Take back</button>
    );
}

/** Hint and finish: what else the user can do to the practice in progress. */
export function PracticeActions() {
    const status = useStore(K.practice.status);
    const line = useStore(K.practice.line);
    // Every move replaces this array, which is what makes the turn below re-read.
    const moves = useStore(K.practice.moves) || [];

    const view = practiceActionsView({
        status,
        hasLine: !!line,
        isUserTurn: !!line && game.turn() === line.color[0],
        hasOwnMove: moves.some((move) => move && move.actor === "user"),
    });

    // Kept in the tree and hidden, as it was: the row has a place in the grid even when empty.
    return (
        <div class={view.hidden ? "toolbar practice-actions hidden" : "toolbar practice-actions"}>
            <button type="button" class="btn btn-ghost btn-sm" disabled={view.hintDisabled}
                    title="Show which piece to move (H). A hinted move earns no XP."
                    onClick={() => practice.hint()}>Hint</button>
            <button type="button" class="btn btn-ghost btn-sm" disabled={view.finishDisabled}
                    title="End the practice here and see your result"
                    onClick={() => practice.finishNow()}>Finish</button>
        </div>
    );
}
